import { UserEvent } from '../UserEventsTypes';
import { importerEvents, ImporterEvents } from './importerEvents';

export interface UserEventsMap {
  importerEvents: Record<ImporterEvents, UserEvent>;
}

export const UserEvents: UserEventsMap = {
  importerEvents
};
